import type { SelectOption } from '../../../../components/inputs/selectShared';
import type { PlantillaVacantItem } from '../personnelTypes';

/**
 * The open SLOTS of one position.
 *
 * The slot is the row a service record is written against, and from 15 Sep 2026 the reader
 * chooses it rather than the server allocating the lowest-numbered one. The cost is stated
 * where the rule is: this list is a moment old, so the server re-checks vacancy on write and
 * a slot taken in between comes back as a rejection rather than a double booking.
 *
 * Ordered by item number, which is how the plantilla reads and how the server used to fill.
 */
export function vacantSlotOptions(
  items: PlantillaVacantItem[],
  positionId: string | null,
): SelectOption[] {
  if (positionId === null) return [];

  return items
    .filter((item) => item.plantillaPositionId === positionId)
    .sort((a, b) => a.itemNumber.localeCompare(b.itemNumber))
    .map((item) => ({ value: item.id, label: item.itemNumber }));
}
